/*
 * PapaPiyay wholesale rules
 * ---------------------------------------------------------------
 * 1. Minimum order quantity is enforced per line item (per item, per size).
 * 2. Wholesale / POS / pallet / liquidation price tiers are removed from the
 *    storefront so only the online price is ever purchasable.
 * 3. Checkout (including express buttons) is blocked while the cart is invalid.
 *
 * NOTE: this is the front-of-house layer. It stops customers using the site.
 * It is NOT a server-side guarantee on its own -- the Cart & Checkout
 * Validation function/app is what makes the rule unbypassable.
 */
(function () {
  'use strict';

  var CFG = window.PPY_WHOLESALE || {};
  var MIN = parseInt(CFG.minQty, 10) || 12;

  var BLOCKED_VALUE_RE = /(point\s*of\s*sale|pointe\s*of\s*sale|point\s*of\s*sales|pallet|liquidation|less\s*(than)?\s*\d*)/i;
  var ONLINE_VALUE_RE = /^\s*online/i;

  var MSG_MIN =
    'Minimum order is ' + MIN + ' units per item, per size. Sizes cannot be combined to reach ' + MIN + '.';

  function all(sel, root) {
    try {
      return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    } catch (e) {
      return [];
    }
  }

  function esc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function isCartPath(url) {
    if (!url) return false;
    return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(String(url));
  }

  function bumpQty(n) {
    var v = parseInt(n, 10);
    if (isNaN(v)) return n;
    if (v <= 0) return v;
    return v < MIN ? MIN : v;
  }

  function applyMinToInput(input) {
    var name = input.getAttribute('name') || '';
    var isCartLine = name.indexOf('updates[') === 0;
    var isProductQty = name === 'quantity';
    if (!isCartLine && !isProductQty) return;

    input.setAttribute('min', String(MIN));
    input.setAttribute('data-min', String(MIN));
    input.setAttribute('step', '1');

    var v = parseInt(input.value, 10);
    if (isProductQty && (isNaN(v) || v < MIN)) input.value = String(MIN);
  }

  function applyMinEverywhere(root) {
    all('input.quantity__input, input[name="quantity"], input[name^="updates["]', root).forEach(applyMinToInput);
  }

  function labelTextFor(input) {
    var id = input.getAttribute('id');
    var lbl = id ? document.querySelector('label[for="' + esc(id) + '"]') : null;
    return (lbl ? lbl.textContent : input.value || '').trim();
  }

  function hideBlockedVariantChoices(root) {
    all('select option', root).forEach(function (opt) {
      var t = (opt.textContent || '').trim();
      if (!t || !BLOCKED_VALUE_RE.test(t)) return;
      opt.hidden = true;
      opt.disabled = true;
      opt.setAttribute('data-ppy-blocked', '1');
      if (opt.selected) {
        var sel = opt.parentNode;
        while (sel && sel.tagName !== 'SELECT') sel = sel.parentNode;
        if (!sel) return;
        var opts = Array.prototype.slice.call(sel.options);
        var replacement =
          opts.filter(function (o) { return !o.disabled && ONLINE_VALUE_RE.test((o.textContent || '').trim()); })[0] ||
          opts.filter(function (o) { return !o.disabled; })[0];
        if (replacement) {
          sel.value = replacement.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    all('.product-form__input input[type="radio"]', root).forEach(function (input) {
      var t = labelTextFor(input);
      if (!t || !BLOCKED_VALUE_RE.test(t)) return;
      input.disabled = true;
      input.setAttribute('data-ppy-blocked', '1');
      var id = input.getAttribute('id');
      var lbl = id ? document.querySelector('label[for="' + esc(id) + '"]') : null;
      if (lbl) lbl.setAttribute('data-ppy-blocked', '1');
      if (input.checked) {
        var group = input.closest('fieldset') || input.parentNode;
        var live = all('input[type="radio"]:not([data-ppy-blocked])', group);
        var replacement = live.filter(function (o) { return ONLINE_VALUE_RE.test(labelTextFor(o)); })[0] || live[0];
        if (replacement) {
          replacement.checked = true;
          replacement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    all('.product-form__input', root).forEach(function (wrap) {
      var legend = wrap.querySelector('legend') || wrap.querySelector('.form__label');
      var name = legend ? (legend.textContent || '').trim() : '';
      if (!/sales\s*chan+el|minimum\s*quantity/i.test(name)) return;
      var live = all('option:not([data-ppy-blocked]), input[type="radio"]:not([data-ppy-blocked])', wrap);
      if (live.length <= 1) wrap.setAttribute('data-ppy-hidden', '1');
    });
  }

  function offendingCartLines() {
    var bad = [];
    all('input[name^="updates["]').forEach(function (input) {
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q === 0) return;
      if (q >= MIN) return;
      var row = input.closest('.cart-item') || input.closest('tr') || input.closest('li');
      var titleEl = row ? row.querySelector('.cart-item__name') : null;
      bad.push({ qty: q, title: titleEl ? titleEl.textContent.trim() : 'Item' });
    });
    return bad;
  }

  function noticeEl() {
    var el = document.getElementById('ppy-cart-notice');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'ppy-cart-notice';
    el.className = 'ppy-notice ppy-notice--error';
    el.setAttribute('role', 'alert');
    return el;
  }

  function placeNotice(el) {
    if (el.parentNode) return;
    var host =
      document.querySelector('.cart__footer') ||
      document.querySelector('cart-drawer .drawer__footer') ||
      document.querySelector('#main-cart-footer') ||
      document.querySelector('.cart__items');
    if (host) host.insertBefore(el, host.firstChild);
  }

  function setCheckoutBlocked(blocked, bad) {
    all('#checkout, button[name="checkout"], .cart__checkout-button, input[name="checkout"]').forEach(function (b) {
      b.disabled = !!blocked;
      b.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      if (blocked) b.classList.add('ppy-blocked');
      else b.classList.remove('ppy-blocked');
    });

    all('#dynamic-checkout-cart, .additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function (n) {
      n.style.display = blocked ? 'none' : '';
    });

    var el = noticeEl();
    if (blocked) {
      var lines = bad
        .map(function (b) {
          return '<li>' + b.title + ' &mdash; ' + b.qty + ' in cart, needs ' + MIN + '</li>';
        })
        .join('');
      el.innerHTML = '<strong>Minimum order not met.</strong><p>' + MSG_MIN + '</p><ul>' + lines + '</ul>';
      placeNotice(el);
    } else if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }

  function validateCart() {
    var bad = offendingCartLines();
    setCheckoutBlocked(bad.length > 0, bad);
  }

  function showFormError(form, msg) {
    var wrap = form.closest('product-form') || form.parentNode;
    if (!wrap) return;
    var box = wrap.querySelector('.ppy-form-error');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ppy-notice ppy-notice--error ppy-form-error';
      box.setAttribute('role', 'alert');
      wrap.insertBefore(box, wrap.firstChild);
    }
    box.textContent = msg;
  }

  function guardProductForms() {
    all('form[action*="/cart/add"]').forEach(function (form) {
      if (form.getAttribute('data-ppy-guard') === '1') return;
      form.setAttribute('data-ppy-guard', '1');
      form.addEventListener(
        'submit',
        function (e) {
          var qty = form.querySelector('input[name="quantity"]');
          var q = qty ? parseInt(qty.value, 10) : MIN;
          if (isNaN(q) || q < MIN) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (qty) qty.value = String(MIN);
            showFormError(form, MSG_MIN);
            return false;
          }
        },
        true
      );
    });
  }

  function fixPayloadObject(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Object.prototype.toString.call(obj.items) === '[object Array]') {
      obj.items.forEach(function (it) {
        if (it && it.quantity != null) it.quantity = bumpQty(it.quantity);
      });
    }
    if (obj.quantity != null) obj.quantity = bumpQty(obj.quantity);
    if (obj.updates && typeof obj.updates === 'object') {
      Object.keys(obj.updates).forEach(function (k) {
        obj.updates[k] = bumpQty(obj.updates[k]);
      });
    }
    return obj;
  }

  function isQtyKey(k) {
    return k === 'quantity' || /^updates\[/.test(k) || /^items\[\d+\]\[quantity\]$/.test(k);
  }

  function fixBody(body) {
    try {
      if (typeof body === 'string') {
        var trimmed = body.replace(/^\s+/, '');
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          return JSON.stringify(fixPayloadObject(JSON.parse(body)));
        }
        var params = new URLSearchParams(body);
        var updates = [];
        params.forEach(function (v, k) {
          if (isQtyKey(k)) updates.push([k, String(bumpQty(v))]);
        });
        updates.forEach(function (p) { params.set(p[0], p[1]); });
        return params.toString();
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var fd = [];
        body.forEach(function (v, k) { if (isQtyKey(k)) fd.push([k, String(bumpQty(v))]); });
        fd.forEach(function (p) { body.set(p[0], p[1]); });
        return body;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var up = [];
        body.forEach(function (v, k) { if (isQtyKey(k)) up.push([k, String(bumpQty(v))]); });
        up.forEach(function (p) { body.set(p[0], p[1]); });
        return body;
      }
    } catch (e) {}
    return body;
  }

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (isCartPath(url) && init && init.body != null) {
          var copy = {};
          for (var k in init) if (Object.prototype.hasOwnProperty.call(init, k)) copy[k] = init[k];
          copy.body = fixBody(init.body);
          init = copy;
        }
      } catch (e) {}
      return _fetch.call(this, input, init);
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ppyUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (isCartPath(this.__ppyUrl) && body != null) body = fixBody(body);
    } catch (e) {}
    return _send.call(this, body);
  };

  function run(root) {
    applyMinEverywhere(root);
    hideBlockedVariantChoices(root);
    guardProductForms();
    validateCart();
  }

  function boot() {
    run(document);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input.quantity__input, input[name^="updates["]')) {
        setTimeout(validateCart, 0);
      }
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name^="updates["]')) {
        setTimeout(validateCart, 0);
      }
    });

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        clearTimeout(window.__ppyT);
        window.__ppyT = setTimeout(function () { run(document); }, 80);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
